<template>
  <div style="font-size: 14px; margin-left: 3px">
    <div>
      <ul class="step">
        <li
          :class="{ current: step === 1 }"
          @click="nextStep(1)"
        >
          ①事業所の設定
        </li>
        <li
          :class="{ current: parseInt(step) === 2 }"
          @click="nextStep(2)"
        >
          ②チームの設定
        </li>
        <li
          :class="{ current: parseInt(step) === 3 }"
          @click="nextStep(3)"
        >
          ③職員の設定
        </li>
        <li
          :class="{ current: step === 4 }"
          @click="nextStep(4)"
        >
          ④勤務区分の設定
        </li>
        <li
          :class="{ current: step === 5 }"
          @click="nextStep(5)"
        >
          ⑤配置人数の設定
        </li>
        <li
          :class="{ current: step === 6 }"
          @click="nextStep(6)"
        >
          ⑥勤務回数の設定
        </li>
        <li
          :class="{ current: step === 7 }"
          @click="nextStep(7)"
        >
          ⑦シフト<br />パターンの設定
        </li>
        <li
          :class="{ current: step === 8 }"
          @click="nextStep(8)"
        >
          ⑧組合せ設定
        </li>
        <li
          :class="{ current: step === 9 }"
          @click="nextStep(9)"
        >
          ⑨回避したいシフト<br />パターン設定
        </li>
        <li
          :class="{ current: step === 10 }"
          @click="nextStep(10)"
        >
          ⑩シフト自動作成
        </li>
      </ul>
    </div>
  </div>
</template>

<style scope>
/* step */
.step {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.step li {
  position: relative;
  display: flex;
  width: calc(100% / 3);
  color: #ffffff;
  justify-content: center;
  align-items: center;
  line-height: 25px;
  background: #d1d1d1;
  cursor: pointer;
}
/* 最初と最後以外は左に余白 */
.step li:not(:first-child):not(:last-child) {
  text-align: center;
  padding: 0 0 0 10px;
}
.step li::before,
.step li::after {
  position: absolute;
  content: '';
  display: block;
  width: 0;
  height: 0;
}
.step li::before {
  top: -7px;
  left: 0;
  border: solid 32px transparent;
  border-right: solid 13px transparent;
  border-left: solid 13px #ffffff;
  z-index: 1;
}
.step li::after {
  top: 0;
  right: -19px;
  border: solid 25px transparent;
  border-left: solid 10px #d1d1d1;
  border-right: solid 10px transparent;
  z-index: 2;
}
/* 最初のliの左と最後 */
.step li:first-child::before,
.step li:last-child::after {
  content: none;
}
.step li.current {
  color: #ffffff;
  background: #ff82b4;
}
.step li.current::after {
  border-left: solid 10px #ff82b4;
}
</style>

<script>
export default {
  name: 'AutoCreateNav',
  components: {},
  props: {
    step: {
      type: Number,
      default: 0,
    },
    is_changed: {
      type: Boolean,
      required: false,
      default: false,
    },
    office_id: {
      type: String,
      required: false,
      default: '',
    },
    team_id: {
      type: Number,
      required: false,
      default: 0,
    },
    year: {
      type: String,
      required: false,
      default: '',
    },
    month: {
      type: String,
      required: false,
      default: '',
    },
    sort_type: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * ローディング
     */
    updateLoading(flg) {
      EventBus.$emit('updateLoading', flg);
    },
    /**
     * ステップバークリック
     */
    nextStep(next_step, message = 0) {
      // 現在のステップが移動先と同じ場合は処理しない
      if (parseInt(this.step) === next_step) return;

      // 入力画面の場合は親画面のほうで保存後、画面遷移を行う
      this.confirm_send(next_step, message);
    },
    /**
     * 変更があれば確認メッセージ
     */
    confirm_send(next_step, message) {
      // 変更があった場合の画面遷移は確認メッセージを出力、なければ遷移
      if (this.is_changed) {
        let disp_message = '保存せずに遷移しますか？';
        if (message === 1) {
          disp_message = '保存せずに戻りますか？';
        } else if (message === 2) {
          disp_message = '保存せずに次へ遷移しますか？';
        } else if (message === 3) {
          disp_message = '保存せずにシフト画面へ戻りますか？';
        }

        this.$swal({
          icon: 'warning',
          title: disp_message,
          showCancelButton: true,
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          showCloseButton: true,
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.go_next_page(next_step);
          }
        });
      } else {
        this.go_next_page(next_step);
      }
    },
    /**
     * 画面遷移
     */
    go_next_page(next_step) {
      const params = {
        is_autocreate: true,
        year: this.year,
        month: this.month,
        office_id: this.office_id,
        team_id: this.team_id,
      };

      try {
        // ローディング開始
        this.updateLoading(true);

        // 事業所管理へ遷移
        if (next_step === 1) {
          this.$inertia.get(route('offices.edit', this.office_id), params);
          // チーム管理へ遷移
        } else if (next_step === 2) {
          this.$inertia.get(route('teams.list'), params);
          // チーム管理へ遷移
        } else if (next_step === 2.1) {
          this.$inertia.get(route('teams.list'), params);
          // 職員管理へ遷移
        } else if (next_step === 3) {
          this.$inertia.get(route('staffs.list'), {
            office_id: this.office_id,
            is_autocreate: true,
            year: this.year,
            month: this.month,
            autocreate_office_id: this.office_id,
            autocreate_team_id: this.team_id,
          });
          // 勤務区分の設定
        } else if (next_step === 4) {
          this.$inertia.get(
            route('offices.workpattern.edit-many', {
              office: this.office_id,
              team_id: this.team_id,
              year: this.year,
              month: this.month,
              sort_type: 1,
            })
          );
          // 常時配置人数の設定
        } else if (next_step === 5) {
          this.$inertia.get(
            route('offices.assignments.edit-many', {
              office: this.office_id,
              team_id: this.team_id,
              year: this.year,
              month: this.month,
            })
          );
          // 勤務回数の設定
        } else if (next_step === 6) {
          this.$inertia.get(
            route('offices.work-counts.edit-many', {
              office: this.office_id,
              team_id: this.team_id,
              year: this.year,
              month: this.month,
              sort_type: 1,
            })
          );
          // シフトパターンの設定
        } else if (next_step === 7) {
          this.$inertia.get(
            this.$route('offices.shift-patterns.edit-many', {
              office: this.office_id,
              team_id: this.team_id,
              year: this.year,
              month: this.month,
              sort_type: 1,
            })
          );
          // 組合せ設定
        } else if (next_step === 8) {
          this.$inertia.get(
            route('offices.combinations.edit-many', {
              office: this.office_id,
              team_id: this.team_id,
              year: this.year,
              month: this.month,
            })
          );
          // 回避したいシフトパターン
        } else if (next_step === 9) {
          this.$inertia.get(
            route('offices.avoid-patterns.edit-many', {
              office: this.office_id,
              team_id: this.team_id,
              year: this.year,
              month: this.month,
            })
          );
          // シフト自動生成
        } else if (next_step === 10) {
          this.$inertia.get(
            route('auto-create.index', {
              office_id: this.office_id,
              team_id: this.team_id,
              year: this.year,
              month: this.month,
            })
          );
          // シフトへ遷移
        } else if (next_step === 11) {
          // パラメータがない場合は、デフォルトのシフト画面へ遷移
          if (!(this.year && this.month && this.office_id)) {
            this.$inertia.get('/shifts/schedule');
          }

          this.$inertia.get(
            this.$route('shifts.schedule', {
              year: this.year,
              month: this.month,
              office: this.office_id,
              team_id: this.team_id,
            })
          );
        }
      } catch (error) {
        this.updateLoading(false);
        this.$swal({
          icon: 'error',
          html: 'システムエラー',
        });
        console.error(error);
      }
    },
  },
};
</script>
